import type { ThemeOptions } from "@mui/material/styles";

export const FONT_SANS =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';
export const FONT_MONO = '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, Consolas, monospace';

export const typography: ThemeOptions["typography"] = {
  fontFamily: FONT_SANS,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: { fontSize: "1.75rem", fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.2 },
  h2: { fontSize: "1.375rem", fontWeight: 700, letterSpacing: "-0.015em", lineHeight: 1.25 },
  h3: { fontSize: "1.125rem", fontWeight: 600, letterSpacing: "-0.01em", lineHeight: 1.3 },
  h4: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.4 },
  h5: { fontSize: "0.9375rem", fontWeight: 600, lineHeight: 1.4 },
  h6: {
    fontSize: "0.8125rem",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
  body1: { fontSize: "0.875rem", lineHeight: 1.55 },
  body2: { fontSize: "0.8125rem", lineHeight: 1.5 },
  subtitle1: { fontSize: "0.875rem", fontWeight: 600 },
  subtitle2: { fontSize: "0.8125rem", fontWeight: 600 },
  button: { fontSize: "0.8125rem", fontWeight: 600, textTransform: "none", letterSpacing: 0 },
  caption: { fontSize: "0.75rem", lineHeight: 1.4 },
  overline: { fontSize: "0.6875rem", fontWeight: 700, letterSpacing: "0.08em" },
};
